import { styled } from 'linaria/react';
import theme from 'clad-ui/theme/chotot';
const Pagination = /*#__PURE__*/styled("div")({
  name: "Pagination",
  class: "pd1mtx4"
});

// const Dot = styled.button.attrs({
//   'aria-label': 'Paging Dot',
// })`
//   height: 6px;
//   width: 6px;
//   cursor: pointer;
//   border: 0px;
//   outline: none;
//   background: #eeeeee;
//   padding: 0px;
//   border-radius: 100%;
//   margin: 0 4px;

//   &.active {
//     background: #9b9b9b;
//   }
// `;
const Dot = /*#__PURE__*/styled("button")({
  name: "Dot",
  class: "dy8q42y"
});
Dot.displayName = 'Dot';
export default Pagination;
export { Dot };

require("../../../.linaria-cache/src/components/SliderHome/Pagination.linaria.module.css");